export default {
  namespaced: true,

  state: () => ({
    newComputer: [],
  }),

  getters: {
    newComputer: ({ newComputer }) => newComputer,
  },

  mutations: {
    addComputer(state, computer) {
      const index = state.newComputer.findIndex(({ id }) => id === computer.id);

      if (computer.checked && index === -1) {
        state.newComputer.push(computer);
      }

      if (!computer.checked && index !== -1) {
        state.newComputer.splice(index, 1);
      }
    },

    clearComputers(state) {
      state.newComputer = [];
    },
  },
};
